import { render } from "./Packages.vue?vue&type=template&id=70181ca8&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"

import "./Packages.vue?vue&type=style&index=0&id=70181ca8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70181ca8"

export default script